import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Anasayfa', path: '/' },
    { name: 'Hizmetler', path: '/hizmetler' },
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'İletişim', path: '/iletisim' },
    { name: 'KVKK', path: '/kvkk' },
    { name: 'Çerez Politikası', path: '/cerez-politikasi' }
  ];

  const services = [
    { name: 'İzmir Detailing', path: '/hizmetler#cam-cizik' },
    { name: 'Pasta Cila', path: '/hizmetler#pasta-cila' },
    { name: 'İç Detaylı Araç Temizliği', path: '/hizmetler#ic-temizlik' },
    { name: 'Far Temizliği', path: '/hizmetler#far-temizlik' },
    { name: 'Deri Tamiri', path: '/hizmetler#deri-tamir' },
    { name: 'Seramik Kaplama', path: '/hizmetler#pasta-cila' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-800 text-gray-200 border-t border-gray-700">
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          
          {/* Şirket Hakkında */}
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/452f2a36a50d364e26f21c2e95baae52.png"
                alt="S&K Detailing"
                className="h-20 w-auto"
              />
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              S&K Detailing, İzmir'de profesyonel oto detailing, pasta cila, iç detaylı temizlik ve araç restorasyonu hizmetleri sunan premium araç bakım merkezidir.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/sk_detailing35/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-600 rounded-full hover:scale-110 transition-transform duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl text-white"></i>
              </a>
              <a
                href="https://wa.me/905050498711?text=Merhaba,%20skdetailing.com.tr%20üzerinden%20iletişime%20geçiyorum."
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-[#25D366] rounded-full hover:scale-110 transition-transform duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-xl text-white"></i>
              </a>
            </div>
          </div>

          {/* Hızlı Menü */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Hızlı Menü</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Hizmetler */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Hizmetler</h3>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer inline-block"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* İletişim Bilgileri */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">İletişim Bilgileri</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-gray-400 text-lg mt-1"></i>
                <span className="text-gray-300 text-sm">677/12. Sk. 40A, 35380 Buca / İzmir</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-gray-400 text-lg"></i>
                <a
                  href="tel:+905050498711"
                  className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  0505 049 87 11
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-instagram-line text-gray-400 text-lg"></i>
                <a
                  href="https://www.instagram.com/sk_detailing35/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  @sk_detailing35
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-10 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} S&K Detailing – Tüm Hakları Saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;